<template>
    <div class="row role-blk" data-action="">
        <div class="col-md-4">
            <div class="input-select-field form-input">
            <select :value="count.role" :data-id="count._id">
                <option value="Dancer">Dancer</option>
                <option value="Musician">Musician</option>
                <option value="Visual Artist">Visual Artist</option>
                <option value="Cinematographer">Cinematographer</option>
                <option value="Other">Other</option>
            </select>
        </div>
        </div>
        <div class="col-md-4">
            <div class="input-field form-input">
                <input type="text" class="specialty" :value="count.specialty" placeholder="Your Specialty">
            </div>
        </div>
        <div class="col-md-2">
            <label :for="`remote_checkbox_`+count" v-on:click="activeFuntion">
                <img src="@/assets/img/check_mark.png" width="45" class="active-checkbox" v-if="count.remote" />
                <img src="@/assets/img/check_mark.png" width="45" v-if="!count.remote" />
            </label>
            <input class="checkbox-remote" type="checkbox" :id="`remote_checkbox_`+count" :checked="count.remote" />
        </div>
        <div class="col-md-2">
            <button type="button" class="btn btn-secondary" v-on:click="deleteItem">Remove</button>
        </div>
    </div>
</template>

<script>
    import $ from "jquery"
    export default {
        name: 'TeamRole',
        props: ['count'],
        data () {
            return {
                roleCount: 1,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods: {
            activeFuntion: function(event){
                $(event.target).toggleClass('active-checkbox')
            },
            deleteItem: function (event) {
                this.$emit('clicked', event)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/include/TeamRole.vue